<template>
  <div class="mpn_mypack mpn_mypack_renew">
    <app-header />
    <mpn-page-title :title="isCheckout ? '주문/결제' : '결제정보 입력'" />
    <main class="a-service-main">
      <div class="a-service-container">
        <div class="cont_section">
          <div class="cart_product-area">
            <div class="akl-toggle-wrap order-items-toggle cart_product-list">
              <check-notice v-model="isCheckNotice" v-if="viewCheckNotice" />
              <delivery-info
                v-if="isDelivery && selectedDeliveryAddress"
                :selected-delivery-address="selectedDeliveryAddress"
                :delivery-list="deliveryList"
                @store-delivery-info="storeDeliveryInfo"
              />
              <sms-receive
                v-if="isFetchAboPhone"
                :is-receive-agreed="isReceiveAgreed"
                :receive-phone="receivePhone"
                :abo-phone="aboPhone"
                @update-sms-receive="updateSmsReceive"
              />
              <payment-methods
                v-if="amwayPayMethods"
                :amway-pay-methods="amwayPayMethods"
                @update-cart-info="updateCartInfo"
                @save-data="saveData"
              />
              <payment-receipt
                v-show="isPaymentReceipt"
                :receipt-type="receiptType"
                :receipt-issuance-type="receiptIssuanceType"
                :receipt-number-type="receiptNumberType"
                :receipt-issuance-number="receiptIssuanceNumber"
                @update-receipt-info="updateReceiptInfo"
              />
              <order-products
                v-for="(pack, packIndex) in orderedProductsData.orderedProducts"
                :key="packIndex"
                :products-info="{
                  products: pack,
                  packName: orderedProductsData.packNames[packIndex],
                }"
              >
                <div class="bottom_action-area btn_full">
                  <a class="btn_basic-d medium" @click="goBack"
                    >이전화면으로 이동</a
                  >
                </div>
              </order-products>

              <p class="product_txt">
                더블엑스 주문 수량은 [골드, 실버, 그린 각 1정 씩 포함된 한
                세트]의 주문 수량입니다.
              </p>
            </div>
            <div class="cart_product-floating js-uxeposfix">
              <payment-summary :total-payment-info="totalPaymentInfo" />
              <!-- E : 20250314 ASB-12383 - 총 결제금액 영역 추가 -->

              <div class="box_cart-option">
                <payment-term
                  :purchase-type="purchaseType"
                  :is-toss-terms-required="isTossTermsRequired"
                  v-model="isPaymentTermsAgree"
                  @open-popup="changeTermsPopup"
                />
                <div class="btn_floating-group">
                  <span class="btn_box">
                    <button
                      v-if="isCheckout"
                      type="button"
                      class="btn_square-a"
                      @click="proceedNext"
                    >
                      <span class="txt_total-price">
                        총<strong class="txt_point-color">
                          {{ totalPaymentInfo.totalPrice }}</strong
                        >원
                      </span>
                      결제하기
                    </button>
                    <button
                      v-else
                      type="button"
                      class="btn_square-a"
                      @click="proceedNext"
                    >
                      결제정보 입력완료
                    </button>
                  </span>
                </div>
                <insurance />
              </div>
            </div>
          </div>
          <div class="box_mobile-floating payment" style="display: none">
            <button
              v-if="isCheckout"
              type="button"
              class="btn_square-a btn_payment-type"
              @click="proceedNext"
            >
              <span class="txt_total-price">
                총<strong class="txt_point-color">{{
                  totalPaymentInfo.totalPrice
                }}</strong
                >원
              </span>
              <span class="txt_point-payment">결제하기</span>
            </button>
            <button
              v-else
              type="button"
              class="btn_square-a btn_payment-type"
              @click="proceedNext"
            >
              결제정보 입력완료
            </button>
          </div>
        </div>
      </div>
      <modal-alert ref="refAlert" />
    </main>
    <app-footer />
    <popup-terms
      :display-modal="displayTermsPopup"
      :terms-id="displayTermsIndex"
      @close-terms="displayTermsPopup = false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import ModalAlert from "@/components/global/ModalAlert";
import DeliveryInfo from "@/views/order/main/components/Receive/DeliveryInfo";
import orderApi from "@/apis/order";
import packApi from "@/apis/pack";
import { DELIVERY_FEE_SKU, PACKAGE_WRAPPING_FEE_SKU } from "@/utils/constants";

import {
  PAYMENT_METHODS,
  AMWAY_PAY_METHODS,
  NORMAL_PAYMENT_METHODS,
  CONTEXT_TYPE,
  ERRORS,
} from "@/utils/constants";
import { log, thousandSeparator } from "@/utils/common";
import PaymentMethods from "@/views/composition/payment/PaymentMethods";
import SmsReceive from "@/views/composition/payment/SmsReceive.vue";
import OrderProducts from "@/views/order/main/components/Products/OrderProducts";
import orderHelpers from "@/utils/helpers/order";
import productHelpers from "@/utils/helpers/product";
import PaymentTerm from "@/views/composition/payment/PaymentTerms.vue";
import PaymentReceipt from "@/views/composition/payment/PaymentReceipt.vue";
import CheckNotice from "@/views/composition/payment/CheckNotice.vue";
import Insurance from "@/views/composition/payment/Insurance.vue";
import PopupTerms from "@/views/order/main/components/PopUpWrappers/PopupTerms";
import PaymentSummary from "@/views/composition/payment/PaymentSummary.vue";

export default {
  name: "CompositionPayment",
  components: {
    AppHeader,
    AppFooter,
    CheckNotice,
    DeliveryInfo,
    PaymentMethods,
    SmsReceive,
    OrderProducts,
    PaymentTerm,
    PaymentReceipt,
    ModalAlert,
    Insurance,
    PopupTerms,
    PaymentSummary,
  },
  props: {},
  data() {
    return {
      isCheckNotice: false,
      deliveryAddress: "",
      deliveryMessage: "",
      isReceiveAgreed: false,
      receivePhone: "",
      paymentMode: "",
      isPaymentTermsAgree: false,
      deliveryList: null,
      amwayPayMethods: null,

      receiptType: "",
      receiptIssuanceType: "",
      receiptNumberType: "",
      receiptIssuanceNumber: "",

      isFetchAboPhone: false,
      aboPhone: "",

      displayTermsPopup: false,
      displayTermsIndex: 0,
    };
  },
  async beforeRouteEnter(to, from, next) {
    if (from.name) {
      sessionStorage.setItem("prevPage", from.fullPath);
    }
    next();
  },
  created() {
    const uuid = this.$route.query.uuid;
    if (uuid) {
      console.log("response : " + this.$route.path);
      const savedState = sessionStorage.getItem("save-vuex");
      if (savedState) {
        const parsedState = JSON.parse(savedState);

        // 현재 store의 appReadyState 유지 (백업에서 가져오지 않음)
        const currentAppReadyState = this.$store.state.appReadyState;
        this.$store.replaceState({
          ...parsedState,
          appReadyState: currentAppReadyState, // 유지
        });
        sessionStorage.removeItem("save-vuex");
      }
      const savedData = sessionStorage.getItem("save-data");
      if (savedData) {
        Object.assign(this.$data, JSON.parse(savedData));
        sessionStorage.removeItem("save-data");
      }
      sessionStorage.removeItem("billingCallbackUrl");
    }

    if (!this.context.bundle || this.finalProducts.length === 0) {
      this.$router.push("/");
    }

    this.fetchAmwayPayMethods();
    this.fetchAboPhone();
  },
  mounted() {
    if(this.isDelivery) {
      // 배송지
      let regularShippingAddressId = "";
      const { deliveryAddress, deliveryMessage } = this.deliveryAddressInfo;
      if (!!deliveryAddress || !!deliveryMessage) {
        this.deliveryAddress = deliveryAddress;
        this.deliveryMessage = deliveryMessage;
        regularShippingAddressId = deliveryAddress || "";
      }
      this.fetchDeliveryList(regularShippingAddressId);
    }

    // 휴대폰 번호
    const receivePhone = this.receivePhoneInfo;
    if (!!receivePhone) {
      this.receivePhone = receivePhone;
    }

    if (this.isChangePayment) {
      this.isReceiveAgreed = true;
    }

    const {
      receiptType,
      receiptIssuanceType,
      receiptNumberType,
      receiptIssuanceNumber,
    } = this.receiptInfo;
    this.receiptType = receiptType;
    this.receiptIssuanceType = receiptIssuanceType;
    this.receiptNumberType = receiptNumberType;
    this.receiptIssuanceNumber = receiptIssuanceNumber;
  },
  computed: {
    ...mapGetters({
      context: "context/context",
      products: "product/products",
      entireProducts: "product/productsAll",
      receivePhoneInfo: "payment/receivePhoneInfo",
      deliveryAddressInfo: "payment/deliveryAddressInfo",
      receiptInfo: "payment/receiptInfo",
      paymentInfo: "payment/paymentInfo",
      selectedAmwayPayAccount: "amwaypay/selectedAmwayPayAccount",
      selectedAmwayPayCard: "amwaypay/selectedAmwayPayCard",
      selectCreditCardBillingInfo:
        "creditcardbilling/selectCreditCardBillingInfo",
      selectQuickAccountBillingInfo:
        "quickaccountbilling/selectQuickAccountBillingInfo",
      accountPassword: "account/password",
    }),
    isCheckout() {
      return (
        this.isReorder && this.isConsultation && this.purchaseType == "single"
      );
    },
    // 체크아웃, 결제정보 변경 페이지에서는 노출하지 않음
    viewCheckNotice() {
      return !(this.isReorder && this.isConsultation) && !this.isChangePayment;
    },
    isReorder() {
      return this.context.name == "composition-reorder";
    },
    isChangePayment() {
      return this.context.name == "composition-payment-with-reqno";
    },
    isConsultation() {
      return this.context.bundle.step3.subscription.isConsultation;
    },
    purchaseType() {
      return this.context.bundle.step3.subscription.purchaseType;
    },
    // 토스 약관 사용 여부
    isTossTermsRequired() {
      if (
        this.paymentMode === AMWAY_PAY_METHODS.ACCOUNT ||
        this.paymentMode === AMWAY_PAY_METHODS.CARD ||
        this.paymentMode === AMWAY_PAY_METHODS.QUICK_ACCOUNT
      ) {
        return true;
      }
      return false;
    },
    isDelivery() {
      return (
        (this.context.bundle &&
          this.context.bundle.step3.subscription.requestType == "VCALL") ||
        this.purchaseType === "recurring"
      );
    },
    isPaymentReceipt() {
      if (
        this.paymentMode === AMWAY_PAY_METHODS.QUICK_ACCOUNT ||
        this.paymentMode === AMWAY_PAY_METHODS.ACCOUNT ||
        this.paymentMode === NORMAL_PAYMENT_METHODS.TRANSFER
      ) {
        return true;
      }
      return false;
    },
    finalProducts() {
      return productHelpers.getProductsFromSkus(
        this.products,
        this.context.bundle.step2.finalSkus
      );
    },
    selectedDeliveryAddress() {
      if (
        !this.deliveryList ||
        this.deliveryList.length == 0 ||
        !this.isDelivery
      ) {
        return null;
      }

      const deliveryAddress = this.deliveryAddress;
      const deliveryMessage = this.deliveryMessage;

      let findDelivery = null;
      if (!!deliveryAddress) {
        findDelivery = this.deliveryList.find(
          (address) => address.id == deliveryAddress
        );
      }
      if (!!deliveryAddress && !findDelivery) {
        this.$refs.refAlert.openWithMessage(
          "배송지 주소 정보가 올바르지 않아 기본 배송지로 변경되었습니다."
        );
      }

      if (!findDelivery) {
        findDelivery = this.deliveryList.find((address) => address.isDefault);
        if(findDelivery === null || findDelivery ===undefined){
          return null;
        }
        this.deliveryAddress = findDelivery.id;
      }
      return {
        cellphone: findDelivery.mobileArea + findDelivery.mobileNumber,
        formattedAddress: findDelivery.defaultAddress.formattedAddress,
        id: findDelivery.id,
        name: findDelivery.name,
        postalCode: findDelivery.defaultAddress.postalCode,
        isDefault: findDelivery.isDefault,
        isRegularShipping: findDelivery.isRegularShipping,
        message: deliveryMessage,
      };
    },
    packName() {
      return this.context.bundle.step3.packName
        ? this.context.bundle.step3.packName
        : "";
    },
    orderedProductsData() {
      return {
        orderedProducts: [
          orderHelpers.refineOrderedProducts(
            this.entireProducts,
            this.productInfos,
            []
          ),
        ],
        packNames: [this.packName],
      };
    },
    productInfos() {
      const productInfos = [];
      const products = this.products;
      const skus = this.context.bundle.step2.finalSkus;
      const requestType = this.context.bundle.step3.subscription.requestType;

      log("products", products);
      log("skus", skus);

      skus.forEach((n) => {
        const p = products.find((m) => n.item_sku === m.item_sku);
        if (p) {
          const productInfo = {
            dose_cnt:
              n.days *
              n.seq
                .split(",")
                .map(Number)
                .reduce((acc, cur) => acc + cur, 0),
            item_sku: n.item_sku,
            price: p.price,
            seq: p.seq,
            pv: p.pv,
            bv: p.bv,
          };
          productInfo.total_price = productInfo.dose_cnt * productInfo.price;
          productInfo.total_pv = productInfo.dose_cnt * productInfo.pv;
          productInfo.total_bv = productInfo.dose_cnt * productInfo.bv;
          productInfos.push(productInfo);
        }
      });

      // 포장비
      const p = products.find((m) => PACKAGE_WRAPPING_FEE_SKU === m.item_sku);
      const productInfo = {
        dose_cnt: this.pockets * this.days,
        item_sku: PACKAGE_WRAPPING_FEE_SKU,
        price: p.price,
        seq: p.seq,
        pv: p.pv || 0,
        bv: p.bv || 0,
      };
      productInfo.total_price = productInfo.dose_cnt * productInfo.price;
      productInfo.total_pv = productInfo.dose_cnt * productInfo.pv;
      productInfo.total_bv = productInfo.dose_cnt * productInfo.bv;
      productInfos.push(productInfo);

      // 배송비
      if (requestType == "VCALL") {
        const totalPrice = productInfos.reduce(
          (sum, product) => sum + product.total_price,
          0
        );
        if (totalPrice < 60000) {
          const p = products.find((m) => DELIVERY_FEE_SKU === m.item_sku);
          const productInfo = {
            dose_cnt: 1,
            item_sku: DELIVERY_FEE_SKU,
            price: p.price,
            seq: p.seq,
            pv: p.pv || 0,
            bv: p.bv || 0,
          };
          productInfo.total_price = productInfo.dose_cnt * productInfo.price;
          productInfo.total_pv = productInfo.dose_cnt * productInfo.pv;
          productInfo.total_bv = productInfo.dose_cnt * productInfo.bv;
          productInfos.push(productInfo);
        }
      }
      return productInfos;
    },
    totalPaymentInfo() {
      const totalPrice = this.productInfos.reduce(
        (sum, product) => sum + product.total_price,
        0
      );

      const totalPv = this.productInfos.reduce(
        (sum, product) => sum + product.total_pv,
        0
      );

      const totalBv = this.productInfos.reduce(
        (sum, product) => sum + product.total_bv,
        0
      );

      const orderPrice = this.productInfos
        .filter(
          (p) =>
            DELIVERY_FEE_SKU != p.item_sku &&
            PACKAGE_WRAPPING_FEE_SKU != p.item_sku
        )
        .reduce((sum, product) => sum + product.total_price, 0);

      const deliveryFee = this.productInfos
        .filter((p) => DELIVERY_FEE_SKU == p.item_sku)
        .reduce((sum, product) => sum + product.total_price, 0);

      const packagingFee = this.productInfos
        .filter((p) => PACKAGE_WRAPPING_FEE_SKU == p.item_sku)
        .reduce((sum, product) => sum + product.total_price, 0);

      return {
        totalPrice: thousandSeparator(totalPrice),
        totalPv: thousandSeparator(totalPv),
        totalBv: thousandSeparator(totalBv),
        totalDiscount: 0,
        orderPrice: thousandSeparator(orderPrice),
        deliveryFee: thousandSeparator(deliveryFee),
        packagingFee: thousandSeparator(packagingFee),
      };
    },
    days() {
      return this.context.bundle.step2.finalSkus[0].days;
    },
    pockets() {
      return this.context.bundle.step2.finalSkus[0].pockets;
    },
    currentPaymentInfo() {
      const paymentMode = this.paymentMode;
      let paymentCode = "";
      let customerId = "";
      let issuerCode = "";
      let issuerName = "";
      let installmentPlan = "";

      if (paymentMode === NORMAL_PAYMENT_METHODS.TRANSFER) {
        // empty
      } else if (paymentMode === NORMAL_PAYMENT_METHODS.CREDIT_CARD) {
        paymentCode = this.selectCreditCardBillingInfo.billingKey;
        issuerCode = this.selectCreditCardBillingInfo.financeCode;
        issuerName = this.selectCreditCardBillingInfo.financeName;
        installmentPlan = "0";
      } else if (paymentMode === AMWAY_PAY_METHODS.ACCOUNT) {
        paymentCode = this.selectedAmwayPayAccount.methodKey;
        customerId = this.selectedAmwayPayAccount.customerId;
      } else if (paymentMode === AMWAY_PAY_METHODS.CARD) {
        paymentCode = this.selectedAmwayPayCard.methodKey;
        customerId = this.selectedAmwayPayCard.customerId;
      } else if (paymentMode === AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
        paymentCode = this.selectQuickAccountBillingInfo.billingKey;
        issuerCode = this.selectQuickAccountBillingInfo.financeCode;
        issuerName = this.selectQuickAccountBillingInfo.financeName;
        customerId = this.selectQuickAccountBillingInfo.customerKey;
      }
      return {
        paymentMode: paymentMode,
        paymentCode: paymentCode,
        customerId: customerId,
        issuerCode: issuerCode,
        issuerName: issuerName,
        installmentPlan: installmentPlan,
      };
    },
    currentReceiptInfo() {
      if (this.isPaymentReceipt) {
        return {
          receiptType: this.receiptType,
          receiptIssuanceType:
            this.receiptType != "NO" ? this.receiptIssuanceType : "",
          receiptNumberType:
            this.receiptType != "NO" ? this.receiptNumberType : "",
          receiptIssuanceNumber:
            this.receiptType != "NO" ? this.receiptIssuanceNumber : "",
        };
      } else {
        return {
          receiptType: "NO",
          receiptIssuanceType: "",
          receiptNumberType: "",
          receiptIssuanceNumber: "",
        };
      }
    },
    isAmwayPayAccountVisible() {
      const now = new Date();
      const hide = new Date("2026-01-01T00:00:00+09:00");
      return now < hide;
    },
  },
  methods: {
    async goBack() {
      const prev = sessionStorage.getItem("prevPage");
      if (prev) {
        await this.$router.push(prev);
        sessionStorage.removeItem("prevPage");
      } else {
        this.$router.back();
      }
    },
    // 모바일 billingkey 페이지 이동 시 현재 data 저장
    saveData() {
      sessionStorage.setItem("save-data", JSON.stringify(this.$data));
    },
    updateSmsReceive(smsReceiveInfo) {
      this.isReceiveAgreed = smsReceiveInfo.isReceiveAgreed;
      this.receivePhone = smsReceiveInfo.receivePhone;
    },
    async fetchDeliveryList(regularShippingAddressId="") {
      const result = await orderApi.getDeliveryList(regularShippingAddressId);
      if (result.error) {
        return;
      }
      this.deliveryList = result;
    },
    async fetchAmwayPayMethods() {
      const result = await orderApi.getAmwayPayMethods();
      log("CompositionPayment::fetchAmwayPayMethods", result);
      if (result.error) {
        return;
      }
      this.amwayPayMethods = result;
    },
    async fetchAboPhone() {
      const result = await orderApi.getAboPhone();
      this.isFetchAboPhone = true;
      log("CompositionPayment::fetchAboPhone", result);
      if (result.error) {
        return;
      }
      this.aboPhone = result;

      if (!this.receivePhone) {
        this.receivePhone = this.aboPhone;
      }
    },
    storeDeliveryInfo(event) {
      log("CompositionPayment::storeDeliveryInfo", event);
      this.deliveryAddress = event.id;
      this.deliveryMessage = event.message;
    },
    async updateCartInfo(event) {
      if (event.paymentMethod === PAYMENT_METHODS.NORMAL) {
        this.paymentMode = event.otherPaymentMethod;
      } else if (event.paymentMethod === PAYMENT_METHODS.AMWAY_PAY) {
        this.paymentMode = event.amwayPayMethod;
      }
      this.$store.dispatch("payment/setPaymentMode", this.paymentMode);
    },

    updateReceiptInfo(receiptInfo) {
      const {
        receiptType,
        receiptIssuanceType,
        receiptNumberType,
        receiptIssuanceNumber,
      } = receiptInfo;
      this.receiptType = receiptType;
      this.receiptIssuanceType = receiptIssuanceType;
      this.receiptNumberType = receiptNumberType;
      this.receiptIssuanceNumber = receiptIssuanceNumber;
    },

    async canProceed() {

      if (this.viewCheckNotice && !this.isCheckNotice) {
        await this.$refs.refAlert.openWithMessage(
          "상담 후 결제 안내 동의가 필요합니다."
        );
        return false;
      }

      if(this.isDelivery && this.deliveryAddress ==="") {
        const addressUrl = `${process.env.HYBRIS_SHIP_URL}`;
        await this.$refs.refAlert.openUrlOnConfirm(
          addressUrl,
          "암웨이 홈페이지에 등록된 기본배송지가 없습니다.\n 암웨이 홈페이지에서 기본배송지를 등록후 다시 주문해주세요."
        );
        return false;
      }

      if (!this.isReceiveAgreed) {
        await this.$refs.refAlert.openWithMessage(
          "알림톡 수신 동의가 필요합니다."
        );
        return false;
      }

      if (this.receivePhone === "") {
        await this.$refs.refAlert.openWithMessage(
          "알림톡 수신 휴대폰 번호를 입력해 주세요."
        );
        return false;
      }

      if (!(this.receivePhone.length == 10 || this.receivePhone.length == 11)) {
        await this.$refs.refAlert.openWithMessage(
          "알림톡 수신 휴대폰 번호가 올바르지 않습니다."
        );
        return false;
      }

      if (!this.paymentMode) {
        await this.$refs.refAlert.openWithMessage("결제수단을 선택해 주세요.");
        return false;
      }

      // payment
      const paymentMode = this.paymentMode;
      if (paymentMode == NORMAL_PAYMENT_METHODS.TRANSFER) {
        if (!this.accountPassword.secret) {
          await this.$refs.refAlert.openWithMessage(
            "자동이체 비밀번호를 입력해 주세요."
          );
          return false;
        } else if (!this.accountPassword.validated) {
          await this.$refs.refAlert.openWithMessage(
            "자동이체 계좌가 존재하지 않거나 비밀번호 인증이 되지 않았습니다."
          );
          return false;
        }
      } else if (paymentMode == NORMAL_PAYMENT_METHODS.CREDIT_CARD) {
        if (
          !this.selectCreditCardBillingInfo.billingKey ||
          !this.selectCreditCardBillingInfo.financeCode ||
          !this.selectCreditCardBillingInfo.financeName
        ) {
          await this.$refs.refAlert.openWithMessage(
            "신용카드 카드정보 등록이 필요합니다."
          );
          return false;
        }
      } else if (paymentMode == AMWAY_PAY_METHODS.ACCOUNT) {
        if (!this.isAmwayPayAccountVisible) {
          await this.$refs.refAlert.openWithMessage(
            "결제수단을 선택해 주세요."
          );
          return false;
        }

        if (!this.selectedAmwayPayAccount.methodKey) {
          await this.$refs.refAlert.openWithMessage(
            "A Pay 계좌를 선택해 주세요."
          );
          return false;
        }
      } else if (paymentMode == AMWAY_PAY_METHODS.CARD) {
        if (!this.selectedAmwayPayCard.methodKey) {
          await this.$refs.refAlert.openWithMessage(
            "A Pay 신용카드를 선택해 주세요."
          );
          return false;
        }
      } else if (paymentMode == AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
        if (
          !this.selectQuickAccountBillingInfo.billingKey ||
          !this.selectQuickAccountBillingInfo.customerKey
        ) {
          await this.$refs.refAlert.openWithMessage(
            "퀵계좌 등록이 필요합니다."
          );
          return false;
        }
      }

      if (this.receiptType == "CASH") {
        if (
          !this.receiptIssuanceType ||
          !this.receiptNumberType ||
          !this.receiptIssuanceNumber
        ) {
          await this.$refs.refAlert.openWithMessage(
            "현금영수증 번호가 입력되지 않았습니다."
          );
          return false;
        }

        // 휴대폰 번호 (10~11)
        if (this.receiptNumberType == "CPN") {
          if (
            !(
              this.receiptIssuanceNumber.length == 10 ||
              this.receiptIssuanceNumber.length == 11
            )
          ) {
            await this.$refs.refAlert.openWithMessage(
              "현금영수증 휴대폰번호가 올바르지 않습니다."
            );
            return false;
          }
        }
        // 현금영수증카드번호 (15~18)
        else if (this.receiptNumberType == "CDN") {
          if (
            !(
              this.receiptIssuanceNumber.length >= 15 &&
              this.receiptIssuanceNumber.length <= 18
            )
          ) {
            await this.$refs.refAlert.openWithMessage(
              "현금영수증 카드번호가 올바르지 않습니다."
            );
            return false;
          }
        }
      }

      if (!this.isPaymentTermsAgree) {
        await this.$refs.refAlert.openWithMessage("약관 동의가 필요합니다.");
        return false;
      }
      return true;
    },
    async proceedNext() {
      const canProceed = await this.canProceed();
      if (!canProceed) {
        return;
      }

      // 일반 재조합인지, 신청번호가 있는 재조합인지 여부에 따라 다른 api호출
      const productDetail = [];
      this.finalProducts.forEach((n) =>
        productDetail.push({
          item_sku: n.item_sku,
          dose: n.pockets,
          dose_list: n.seq,
        })
      );

      const dataForGettingAppliedDetail = {
        packName: this.packName,
        takeDays: this.days,
        orderType: "",
        abcCd: this.context.bundle.step3.subscription.abcCd,
        totalPrice: this.context.bundle.step3.prices.price,
        totalPv: this.context.bundle.step3.prices.pv,
        totalBv: this.context.bundle.step3.prices.bv,
        dose: this.pockets,
        detail: productDetail,
        reqNo: this.context.bundle.step3.reqNo,
        cfm_kind: this.context.bundle.step3.subscription.requestType,
        purchaseType: this.context.bundle.step3.subscription.purchaseType,
        receivePhone: this.receivePhone,
        deliveryAddress: this.deliveryAddress,
        deliveryMessage: this.deliveryMessage,
        billingDate: this.context.bundle.step3.subscription.billingDate,
        billingStatus: this.context.bundle.step3.subscription.billingStatus,
        paymentInfo: { ...this.currentPaymentInfo, ...this.currentReceiptInfo },
      };

      log("dataForGettingAppliedDetail", dataForGettingAppliedDetail);
      log("this.context.name", this.context.name);

      let r = {};
      if (
        this.context.name === CONTEXT_TYPE.RECOMPOSITION_WITH_REQNO ||
        this.context.name === CONTEXT_TYPE.COMPOSITION_PAYMENT_WITH_REQNO
      ) {
        r = await packApi.updateCompleteAppliance(dataForGettingAppliedDetail);
      } else {
        r = await packApi.postCompleteAppliance({
          ...dataForGettingAppliedDetail,
          reorder: this.isReorder,
          consultation: this.isConsultation,
        });
      }
      if (r.error) {
        console.error(r.error);
        return;
      }

      // 재주문, 상담승인, 1회 구매인 경우
      if (this.isCheckout) {
        const { result, error } = await orderApi.placeOrder(r.req_no);
        log("placeOrder", result, error);

        if (error || !result) {
          await this.$refs.refAlert.openWithMessage(
            "마이팩은 생성되었으나, 입력하신 결제 정보로 결제가 완료되지 않았습니다.\n마이팩 목록에서 생성하신 마이팩에 대해 즉시 결제를 해주세요."
          );
          await this.resetStore();
          await this.$router.replace("/mypacks");
          return;
        }

        this.$router.push({
          name: "order-complete",
          params: {
            orderResult: result,
          },
        });
      } else if (this.isChangePayment) {
        await this.$refs.refAlert.openWithMessage(
          "결제 정보가 수정되었습니다."
        );
        await this.resetStore();
        await this.goBack();
      } else {
        r.req_date = r.re_reg_date;
        this.$router.push({
          name: "composition-complete",
          params: {
            appliedStateDetail: r,
            productsDetails: this.finalProducts,
            pockets: this.pockets,
            days: this.days,
          },
        });
      }
    },
    changeTermsPopup(event) {
      this.displayTermsPopup = event.display;
      this.displayTermsIndex = event.index;
    },
    async resetStore() {
      await this.$store.dispatch("context/unset");
      await this.$store.dispatch("agreement/init");
      await this.$store.dispatch("payment/reset");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/payment/CompositionPayment.vue